export enum CardType {
  COMMUNITY = 'community',
  PROJECT = 'project',
  POST = 'post',
  USER = 'user',
  ORGANIZATION = 'organization',
  PATIENT = 'patient',
  DOCTOR = 'doctor',
  MED_STAFF = 'med_staff',
  RESEARCHER = 'researcher',
  COMMENT = 'comment',
}

export enum InviteCardType {
  INVITE_TO_COMMUNITY = 'InviteToCommunity',
  INVITE_TO_PROJECT = 'InviteToProject',
}
